<template>
    <svg width="20" height="4" viewBox="0 0 20 4" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.265 3.837c.497 0 .916-.16 1.257-.478.341-.32.512-.72.512-1.204 0-.505-.17-.927-.512-1.264a1.72 1.72 0 0 0-1.257-.505H2.219c-.497 0-.916.16-1.257.479-.341.318-.512.73-.512 1.232 0 .497.17.912.512 1.243.341.331.76.497 1.257.497h15.046z" fill="#168171" fill-rule="nonzero"/>
    </svg>
</template>

<script>
export default {
    name: 'IconMinus',
};
</script>
